import React from 'react';
import Button from '../../common/Skeleton/Button';
import commonStyle from '../index.scss';
import style from './index.scss';

export default () => (
    <div className={commonStyle.container}>
        <div className={commonStyle.fixedContainer}>
            <div className={style.container}>
                <div className={style.statusBadge} />
                <div className={style.lbName} />
                <Button className={style.joinButton} />
                <div className={style.compContainer}>
                    <div className={style.compTitle} />
                    <div className={style.compTable} />
                </div>
                <div className={style.infoContainer}>
                    <div className={style.infoList} />
                    <div className={style.countdown} />
                </div>
                <div className={style.gamesContainer}>
                    <div className={style.gamesTitle} />
                    <div className={style.gamesTabs}>
                        <Button className={style.gamesTab} />
                        <Button className={style.gamesTab} />
                    </div>
                    <div className={style.gamesList}>
                        <div className={style.gameItem} />
                        <div className={style.gameItem} />
                        <div className={style.gameItem} />
                        <div className={style.gameItem} />
                    </div>
                </div>
            </div>
        </div>
    </div>
);
